import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://079c84149364a23f3b8ee6be7ed3b9e6@o4509359942467584.ingest.us.sentry.io/4511902754013184",

  // Environment and Release tracking
  environment: process.env.REACT_APP_ENV || process.env.NODE_ENV || "development",
  release: `cms-frontend@${process.env.REACT_APP_VERSION || "0.1.0"}`,

  integrations: [
    // 1. Performance Monitoring & Core Web Vitals (LCP, FID, CLS, FCP, TTFB, INP)
    Sentry.browserTracingIntegration({
      enableLongTask: true,        // Tracks long tasks blocking the main UI thread (>50ms)
      enableElementOrigin: true,    // Tracks element origin for UI interactions
    }),
    
    // 2. Session Replay
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  // Performance Tracing Sampling Rate
  // 100% in development/staging, 20% in production for optimal quota usage
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.2 : 1.0,

  // Control URLs for which Distributed Tracing headers should be attached
  tracePropagationTargets: [
    "localhost",
    /^\//,
    process.env.REACT_APP_API_URL,
  ].filter(Boolean),

  // Session Replay Rates
  replaysSessionSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 0.5,
  replaysOnErrorSampleRate: 1.0,

  enableLogs: true,
});
